/* eslint-disable no-restricted-globals */
export default function isValidDate(date) {
    return !isNaN(new Date(date));
}
